import { Box, Button } from '@mui/material';
import { useViewStore } from '@/stores';
import type { Question } from '@/types';

export default function ExplanationToggle({ question }: { question: Question }) {
  const { showExplanations, toggleShowExplanations } = useViewStore();
  const { id, explanationNode, answers } = question;

  const toggleExplanation = () => {
    toggleShowExplanations(id);
  };

  const explanationIsActive = showExplanations.indexOf(id) > -1;
  const hasExplanations = !!explanationNode || answers?.some((answer) => !!answer.explanationNode);

  return (
    <Box sx={{ py: 2 }}>
      {hasExplanations && (
        <Button onClick={toggleExplanation} variant="outlined" size="small">
          Erläuterungen {explanationIsActive ? 'ausblenden' : 'einblenden'}
        </Button>
      )}
    </Box>
  );
}
